<template>
    <div ref="testResults">
        <div class="level">
            <div class="level-item level-left">
                <b-select v-model="filter.applicationId" @input="getTestResults">
                    <option :value="null">All Test Result</option>
                        <option
                            v-for="option in applications"
                            :value="option.id"
                            :key="option.id">
                            {{ option.name }}
                        </option>
                </b-select>
            </div>
            <div class="level-right level-item">
                <b-checkbox v-model="filter.showArchive" :native-value="true" type="is-dark">
                    Show Hidden
                </b-checkbox>
                <b-button @click="getTestResults" class="m-r-xs" icon-left="sync"/>
            </div>
        </div>
        <b-table :data="testResults" :columns="columns">
            <template slot-scope="props" v-if="filter.showArchive ? true : props.row.attributes.status">
                <b-table-column>
                    <div class="columns">
                        <span class="column is-full">
                            {{props.row.attributes.name}}
                        </span>
                    </div>
                </b-table-column>
                <b-table-column>
                    <div class="columns">
                        <span class="column is-full">
                            {{props.row.attributes.status}}
                        </span>
                    </div>
                </b-table-column>
                <b-table-column>
                    <div class="columns">
                        <span class="column is-full">
                            {{props.row.attributes.job_id}}
                        </span>
                    </div>
                </b-table-column>
                <b-table-column>
                    <b-select v-model="props.row.attributes.application_id" @input="save(props.row)">
                        <option
                            v-for="option in applications"
                            :value="option.id"
                            :key="option.id">
                            {{ option.name }}
                        </option>
                        <option :value="null">Not Assigned</option>
                    </b-select>
                </b-table-column>
                <b-table-column>
                    <div class="columns">
                        <span class="column is-full">
                            {{props.row.attributes.created_at | date}}
                        </span>
                    </div>
                </b-table-column>
                <b-table-column>
                    <div class="buttons">
                        <b-button @click="copy(props.row)" :loading="copying[props.row.id]">
                            Copy
                        </b-button>
                        <b-button :disabled="props.row.attributes.is_steps_exists" @click="extract(props.row)" v-if="props.row.attributes.application_id">
                            Import
                        </b-button>
                        <b-button @click="restore(props.row)" v-if="props.row.attributes.archived_at">
                            Restore
                        </b-button>
                        <b-button @click="archive(props.row)" v-else>
                            Archive
                        </b-button>
                    </div>
                    <b-progress :value="getValueProgress(props.row)" v-if="props.row.attributes.progress" show-value format="percent"></b-progress>
                </b-table-column>
            </template>
        </b-table>
        <hr>
        <b-pagination
            :total="pagination.total"
            :current.sync="pagination.currentPage"
            :order="pagination.order"
            :size="pagination.size"
            :simple="false"
            :rounded="false"
            :per-page="pagination.perPage"
        ></b-pagination>
    </div>
</template>
<script>
import Vue from 'vue';

export default {
    data() {
        return {
            applications:[],
            filter:{
                applicationId:null,
                showArchive:false
            },
            pagination: {
                total: 0,
                currentPage: 1,
                perPage: 0,
                order: "default",
                size: "default"
            },
            columns:[
                {
                    field:'name',
                    label:'Name'
                },
                {
                    field:'status',
                    label:'Status'
                },
                {
                    field:'job_id',
                    label:'Job Id'
                },
                {
                    field:'application_id',
                    label:'Application'
                },
                {
                    field:'date',
                    label:'Date'
                },
                {
                    field:'actions',
                    label:'Actions'
                }
            ],
            testResults:[],
            copying: {},
        }
    },
    watch:{
        async 'filter.applicationId'(){
            this.pagination.currentPage=1;
            await this.getTestResults()
        },
        async 'filter.showArchive'(){
            this.pagination.currentPage=1;
            await this.getTestResults()
        },
        async 'pagination.currentPage'(){
            await this.getTestResults();
        },
    },
    async mounted() {
        await this.getApps();
        await this.getTestResults()
    },
    methods:{
        async getTestResults(){
            const loadingComponent = this.$buefy.loading.open({
                container: this.$refs.testResults
            })
            let params = await this.getParams()
            Vue.$testResultService.getList(params).then((response)=>{
                this.testResults = response.data;
                this.pagination.total = response.meta.pagination.total;
                this.pagination.perPage = response.meta.pagination.per_page;
                this.pagination.currentPage = response.meta.pagination.current_page;
                loadingComponent.close()
            })
        },
        getParams() {
            let params = `?page=${this.pagination.currentPage}`
            if(this.filter.applicationId){
                params+=`&application_id=${this.filter.applicationId}`
            }
            if(this.filter.showArchive){
                params+=`&archive=${this.filter.showArchive}`
            }

            return params
        },
        getApps(){
            Vue.$appService.appList().then((response)=>{
                this.applications = response
            })
        },
        save(row){
            Vue.$testResultService.update(row.id,{
                name:row.attributes.name,
                application_id:row.attributes.application_id
            }).then(()=>{
                this.$buefy.toast.open({
                    type: 'is-success',
                    message: 'Test result updated!'
                })
                this.getTestResults()
            })
        },
        archive(row){
            Vue.$testResultService.update(row.id,{
                name:row.attributes.name,
                is_archived:true
            }).then(()=>{
                this.$buefy.toast.open({
                    type: 'is-success',
                    message: 'Test result archived!'
                })
                this.getTestResults()
            })
        },
        restore(row){
            Vue.$testResultService.update(row.id,{
                name:row.attributes.name,
                is_archived:false
            }).then(()=>{
                this.$buefy.toast.open({
                    type: 'is-success',
                    message: 'Test result restored!'
                })
                this.getTestResults()
            })
        },
        extract(row){
            Vue.$testResultService.extractSteps({id:row.id}).then(()=>{
                this.$buefy.toast.open({
                    type:'is-success',
                    message:'Extracting the steps has started'
                });
                this.getTestResults()
            })
        },
        getValueProgress(row){
            let progress = row.attributes.progress
            return (progress.currentStep/progress.totalSteps)*100
        },
        copy(row) {
            this.$set(this.copying, row.id, true);
            Vue.$testResultService.cloneSteps(row.id).then((response) => {
                const topic = response;
                this.$buefy.toast.open({
                    type: "is-success",
                    message: `Test result has been copied to topic - ${topic.title}`
                });
            })
            .finally(() => {
                this.$set(this.copying, row.id, false);
            });
        },
    }
}
</script>